/**
 * Calendar Events Context
 * Provides events data to calendar cell components
 */

import React, { createContext, useContext } from 'react';

const CalendarEventsContext = createContext({});

export const useCalendarEvents = () => useContext(CalendarEventsContext);

export const CalendarEventsProvider = ({ children, events }) => {
  // Create a map of date string to events for quick lookup
  const eventsByDate = React.useMemo(() => {
    const map = {};

    if (events && Array.isArray(events)) {
      events.forEach(event => {
        if (event.start) {
          const dateKey = new Date(event.start).toDateString();
          if (!map[dateKey]) {
            map[dateKey] = [];
          }
          map[dateKey].push(event);
        }
      });
    }

    return map;
  }, [events]);

  return (
    <CalendarEventsContext.Provider value={{ events, eventsByDate }}>
      {children}
    </CalendarEventsContext.Provider>
  );
};
